var React = require('react');

function BookInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"80","height":"80","rx":"16","fill":"#1565D8","fillOpacity":"0.06","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40.0391 41H57.0391C57.5913 41 58.0391 41.4477 58.0391 42C58.0391 52.4934 49.5325 61 39.0391 61C28.5457 61 20.0391 52.4934 20.0391 42C20.0391 31.5066 28.5457 23 39.0391 23C39.5913 23 40.0391 23.4477 40.0391 24V41Z","fill":"#1565D8","key":1}),React.createElement("path",{"opacity":"0.3","d":"M62.043 35.999C62.043 36.5513 61.5953 36.999 61.043 36.999H45.043C44.4907 36.999 44.043 36.5513 44.043 35.999V19.999C44.043 19.4467 44.4907 18.999 45.043 18.999C54.4318 18.999 62.043 26.6102 62.043 35.999Z","fill":"#1565D8","key":2})]);
}

BookInline.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = BookInline;

BookInline.default = BookInline;
